import { responsiveContainer } from "@huub-web/ui/utils/responsive";
import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

import { theme } from "@huub-web/ui/theme/css/theme.css";

export const iconStyle = style({});

export const priceStyle = style({
  paddingTop: theme.spacings.xxs,
});

export const descriptionStyle = style({
  maxWidth: rem(620),
  margin: "0 auto",
});

export const gridStyle = style({
  gap: theme.spacings.s,
  gridTemplateColumns: "repeat(1, 1fr)",
  ...responsiveContainer({
    500: {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  }),
});
